<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
};
</script>

<style>
:root {
  --admin-bg: #0b1220;
  --admin-bg-soft: #111b30;
  --admin-surface: rgba(255, 255, 255, 0.84);
  --admin-surface-strong: rgba(255, 255, 255, 0.92);
  --admin-border: rgba(148, 163, 184, 0.18);
  --admin-border-strong: rgba(148, 163, 184, 0.28);
  --admin-text: #111827;
  --admin-text-secondary: #64748b;
  --admin-primary: #7fb5ff;
  --admin-primary-strong: #4f8fff;
  --admin-success: #2dcf85;
  --admin-shadow: 0 26px 60px rgba(15, 23, 42, 0.12);
}

* {
  box-sizing: border-box;
}

html,
body,
#app {
  margin: 0;
  height: 100%;
}

body {
  font-family: 'SF Pro Display', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  color: var(--admin-text);
  background:
    radial-gradient(circle at top left, rgba(126, 172, 255, 0.16), transparent 32%),
    radial-gradient(circle at right bottom, rgba(90, 140, 255, 0.14), transparent 28%),
    linear-gradient(180deg, #f5f7fb 0%, #eef2f7 100%);
}

a {
  color: inherit;
  text-decoration: none;
}

.page-container {
  border-radius: 28px;
  border: 1px solid var(--admin-border);
  box-shadow: var(--admin-shadow);
  background: var(--admin-surface-strong);
  overflow: hidden;
}

.page-header {
  margin-bottom: 22px;
}

.el-card,
.el-dialog,
.el-message-box {
  border-radius: 24px !important;
  border: 1px solid var(--admin-border) !important;
  box-shadow: var(--admin-shadow) !important;
}

.el-card,
.el-dialog {
  background: var(--admin-surface-strong) !important;
}

.el-input__inner,
.el-textarea__inner {
  border-radius: 16px !important;
  border-color: #d9e2ee !important;
  background: rgba(249, 250, 251, 0.92) !important;
  transition: border-color 0.24s ease, box-shadow 0.24s ease, background 0.24s ease !important;
}

.el-input__inner:focus,
.el-textarea__inner:focus {
  border-color: rgba(79, 143, 255, 0.46) !important;
  box-shadow: 0 0 0 4px rgba(127, 181, 255, 0.16) !important;
  background: #fff !important;
}

.el-button {
  border-radius: 16px !important;
}

.el-button--primary {
  border: none !important;
  background: linear-gradient(135deg, #142033, #293956) !important;
  box-shadow: 0 14px 28px rgba(15, 23, 42, 0.18) !important;
}

.el-button--primary:hover,
.el-button--primary:focus {
  background: linear-gradient(135deg, #18263d, #314565) !important;
}

.el-table {
  border-radius: 20px;
  overflow: hidden;
}

.el-table th.is-leaf,
.el-table td {
  border-bottom-color: rgba(226, 232, 240, 0.8) !important;
}

.el-table::before {
  display: none;
}

.el-pagination button,
.el-pagination span:not([class*=suffix]),
.el-pagination .el-pager li {
  border-radius: 12px;
}

.el-page-header {
  padding: 2px 0 18px;
}

.el-page-header__content {
  font-weight: 600;
  color: var(--admin-text);
}

.el-breadcrumb__inner,
.el-breadcrumb__inner a {
  color: var(--admin-text-secondary) !important;
}
</style>
